<script>
  import { getContext, onMount } from 'svelte';

  import Loader from '../../components/ui/loader.html';
  import Sponsor from './components/sponsor.html';
  import Plus from '../../components/buttons/plus';
  import RouterLink from '../../utils/link';
  import Search from '../../components/inputs/search';

  import { SEARCH_SPONSORS } from '../../graphql/sponsors';

  const client = getContext('apollo');

  let search = '';
  let query = client.watchQuery({
    query: SEARCH_SPONSORS,
    variables: { search },
    fetchPolicy: 'network-only'
  });
  let results = { loading: true };

  function setResponse({ data, loading, error, networkStatus }) {
    results = {
      loading,
      page: data && data.sponsors ? data.sponsors.page : 1,
      total: data && data.sponsors ? data.sponsors.total : 0,
      sponsors: data && data.sponsors ? data.sponsors.docs : []
    };
  }

  const subscription = query.subscribe({
    next: nextResult => {
      setResponse(nextResult);
    },
    error: error => {
      setResponse({ error, loading: false });
    }
  });

  function searchSponsors() {
    query.refetch({ search, page: 1 });
  }

  function loadMore() {
    query.fetchMore({
      variables: {
        search,
        page: results.page + 1
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        return Object.assign({}, prev, {
          sponsors: {
            ...fetchMoreResult.sponsors,
            docs: [...prev.sponsors.docs, ...fetchMoreResult.sponsors.docs]
          }
        });
      }
    });
  }
</script>

<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-6">
    <h1>{results.total || 0} Sponsors</h1>
  </div>
  <div class="cell small-12 medium-6 text-right">
    <RouterLink href="/sponsors/new">
      <Plus label="ADD SPONSOR"></Plus>
    </RouterLink>
  </div>
  <div class="cell small-12 medium-12">
    {#if results.loading}
    <Loader></Loader>
    {/if} {#if !results.loading}
    <div class="grid-x grid-margin-x small-up-1 medium-up-3">
      {#each results.sponsors as sponsor, i}
      <div class="cell">
        <Sponsor sponsor="{sponsor}"></Sponsor>
      </div>
      {/each}
    </div>
    {/if}
  </div>
</div>
